export default __webpack_public_path__ + "fonts/45d5f819720e994a84d78f234b33defa.svg";